export default [
  '产品货架拍摄不完整，需按节拍摄该品类所有货架',
  '请拍摄指定区域地堆、端架照片，非主货架照片',
  '照片未体现指定产品',
  '照片拍摄模糊无法辨识',
  '需正面拍摄产品货架（清晰体现货架顶端和底端）',
  '非任务要求检查人员',
  '非任务要求检查时段',
  '非任务要求检查区域',
  '产品未按理货要求饱满陈列',
  '产品商标未按理货要求正面朝外',
]



// WEBPACK FOOTER //
// ./src/views/question-review/components/ReviewBox/src/error-msg-options.js